module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#stories",
      toString: function () {
        return this.url;
      }
    }